import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/game/share/init', method: 'GET', params }, { interceptResultCode: false });
}

// 助力
export const helpDataAPI = (params) => {
  return axios({ url: '/snail/game/share/help', method: 'GET', params }, { interceptResultCode: false });
}

// 下载
export const downloadApps = (params) => {
  return axios( { url: "/jump/download/url", method: "POST", params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/snail/ending/api.js